/* eslint-disable react/jsx-pascal-case */
import { useComponent } from '@uswitch/ev-utils/context/selectors'
import { toKebabCase } from '@uswitch/ev-utils/string'
import { Type } from '@uswitch/spark.type'
import { Themed } from 'theme-ui'

import { BLOCKS as B, INLINES as I, MARKS as M } from '@contentful/rich-text-types'
import { LinkWithChevron as Link, Palette } from '@uswitch/ev-core/react'
import Filter from '../helpers/filtered'
import { moduleEntity } from '../helpers/modules'

import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

const paletteHeading = as => (node, text) => (
  <Palette
    as={as}
    px={{ color: palette => palette.headingColor || palette.textColor }}
    id={toKebabCase(documentToPlainTextString(node) || '')}
  >
    {text}
  </Palette>
)

export const Options = (config = {}) => {
  const {
    observedWaypoints,
    optionOverrides = { renderMark: {}, renderNode: {} },
    ...extraData
  } = config
  const out = {
    renderMark: {
      [M.BOLD]: text => <b>{text}</b>,
      [M.ITALIC]: text => <i>{text}</i>,
      [M.UNDERLINE]: text => <span sx={{ textDecoration: 'underline' }}>{text}</span>,
      [M.CODE]: text => <Themed.strong>{text}</Themed.strong>,
      ...optionOverrides.renderMark,
    },

    renderNode: {
      [B.EMBEDDED_ASSET]: node =>
        moduleEntity(node.data.target, {
          ...extraData,
          spacing: node.spacing,
          tag: 'embeddedAsset',
        }),
      [B.EMBEDDED_ENTRY]: node => moduleEntity(node.data.target, extraData),
      [B.HEADING_1]: paletteHeading(Type.H1),
      [B.HEADING_2]: (node, text) => {
        const id = toKebabCase(documentToPlainTextString(node) || '')

        return (
          <Palette
            as={Type.H2}
            px={{ color: palette => palette.headingColor || palette.textColor }}
            {...(observedWaypoints && observedWaypoints[id]
              ? { ref: observedWaypoints[id][1] }
              : {})}
            id={id}
          >
            {text}
          </Palette>
        )
      },
      [B.HEADING_3]: paletteHeading(Type.H3),
      [B.HEADING_4]: paletteHeading(Type.H4),
      [B.HEADING_5]: paletteHeading(Type.H5),
      [B.HEADING_6]: paletteHeading(Type.H6),
      [B.HR]: () => <Themed.hr />,
      [B.UL_LIST]: (_, text) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [, List] = useComponent({ tag: 'list' })
        return <List listType='bullet'>{text}</List>
      },
      [B.OL_LIST]: (_, text) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [, List] = useComponent({ tag: 'list' })
        return <List listType='numeric'>{text}</List>
      },
      [B.LIST_ITEM]: (_, text) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [, ListItem] = useComponent({ tag: 'listItem' })
        return <ListItem>{text}</ListItem>
      },
      [I.HYPERLINK]: (node, text) => (
        <Filter when={text.join('').length}>
          <Link {...extraData} href={node.data.uri}>
            {text}
          </Link>
        </Filter>
      ),
      [B.PARAGRAPH]: (node, text) => (
        <Filter when={text.join('').length}>
          <Palette as='p' sx={{ variant: 'styles.p' }} px={{ color: 'textColor' }}>
            <For each='content' index='i' of={text}>
              {content}
              <If condition={typeof content === 'string' && content.endsWith('\n')}>
                <br />
              </If>
            </For>
          </Palette>
        </Filter>
      ),
      [B.QUOTE]: (node, text) => <Themed.blockquote>{text}</Themed.blockquote>,
      ...optionOverrides.renderNode,
    },
  }
  return out
}

export default Options
